import React from 'react';
import './../../style/Header.css';
import HeaderNavi from './HeaderNavi'
import HeaderContents from './HeaderContents'


class Header extends React.Component{
    constructor (props) {
        super(props);
        this.state = {
            'title' : 'MEONGCA'
        };
    }

    render(){
        return (
            <div className='app-header'>
                <HeaderNavi title={this.state.title} />
                <HeaderContents />
            </div>
        )
    }
}
    
export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js